import React from "react";

/**
 * TextArea component
 *
 * Props:
 *  - label?: string
 *  - name: string
 *  - value: string
 *  - placeholder?: string
 *  - onChange: (e) => void
 *  - rows?: number
 *  - disabled?: boolean
 */
export function TextArea({
  label,
  name,
  value,
  placeholder = "",
  onChange,
  rows = 4,
  disabled = false,
}) {
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}
      <textarea
        name={name}
        value={value}
        placeholder={placeholder}
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-50 disabled:text-gray-500 disabled:cursor-not-allowed resize-vertical transition-colors"
        onChange={onChange}
        rows={rows}
        disabled={disabled}
      />
    </div>
  );
}